import ProductLink from "../../../../src/components/ProductLink";
import * as React from 'react';
export default {
  ProductLink,
  React
};